export const CREATED = 'created';
export const UPDATED = 'updated';
export const SKIPPED = 'skipped';
export const FAILED = 'failed';

export default {
  CREATED,
  UPDATED,
  SKIPPED,
  FAILED
};
